<bc-table-container *ngIf="data" class="bc-col-lg-12" [dataTable]="data!.content">
    <bc-table-header title="Facturas" [actionsSelections]="actions">
        <bc-paginator type="full" [totalRegisters]="data.totalElements.toString()" [perPage]="data!.size.toString()"
            perMultiple="5" (onChangePage)="onChangePage($event)">
        </bc-paginator>
    </bc-table-header>
    <bc-table-content>
        <table caption="tabla" bc-table [sort]="true" [pairPaginators]="true" [scroll]="true">
            <thead>
                <tr>
                    <th scope="row" bc-cell scope="col" style="width: 10px;">NIT</th>
                    <th scope="row" bc-cell scope="col">Número</th>
                    <th scope="row" bc-cell scope="col">Tipo</th>
                    <th scope="row" bc-cell scope="col">Remitente</th>
                    <th scope="row" bc-cell scope="col">Fecha</th>
                    <th scope="row" bc-cell scope="col">Ciudad</th>
                    <th scope="row" bc-cell scope="col">Estado</th>
                    <th scope="row" bc-cell scope="col" type="action">Detalle</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of data.content">
                    <td bc-cell>{{ row.nit }}</td>
                    <td bc-cell>{{ row.numero_factura }}</td>
                    <td bc-cell>{{ row.tipo_documento?.significado }}</td>
                    <td bc-cell>{{ row.remitente }}</td>
                    <td bc-cell>{{ row.fecha_creacion }}</td>
                    <td bc-cell>{{ row.ciudad }}</td>
                    <td class="cell-size-estados">                                               
                        <label [className]="procesarCss(row.estado.codigo)">{{ row.estado.nombre }}</label> 
                    </td>
                    <td bc-cell  class="cell-size-detalle">
                        <button bc-button class="btnVerDetalle" sizeButton="small" typeButton="primary" [routerLink]="['/home/detalle', row.numero_factura]">Ver</button>                                    
                    </td>
                </tr>
            </tbody>
        </table>
    </bc-table-content>
</bc-table-container>